// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import PaymentAccountSelect from './data'

export default function PaymentAccountSelectFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/PaymentAccount/PaymentAccountSelect">
      <PaymentAccountSelect {...props}>
        {children}
      </PaymentAccountSelect>
    </Flow>
  )
}
